import ProductLink from 'components/products/product-link';
import { AirHandlerProductType, CondenserProductType } from 'data/types';
import {
  equipmentPlaceholderNote,
  isEquipmentPlaceholderProduct
} from 'utils/equipment-placeholder';

type DuctedLineSetProductNameProps =
  | { type: 'condenser'; product: CondenserProductType }
  | { type: 'air handler'; product: AirHandlerProductType };

export default function DuctedLineSetProductName({
  type,
  product
}: DuctedLineSetProductNameProps) {
  if (isEquipmentPlaceholderProduct(product)) {
    const note = equipmentPlaceholderNote(product);
    return (
      <span className='font-semibold'>
        {product.name}
        {note && (
          <span className='font-normal italic text-gray-400'> {note}</span>
        )}
      </span>
    );
  }

  if (type === 'condenser') {
    return (
      <ProductLink type='condenser' product={product} fullName hoverInfo />
    );
  }

  return (
    <ProductLink type='air handler' product={product} fullName hoverInfo />
  );
}
